import React from 'react';
import { AppShell } from './AppShell';
import { classNames } from '../../utils/classNames';

export const DashboardLayout = ({
  title,
  actions,
  startActions,
  children,
  contentClassName,
  flush = false
}) => (
  <AppShell
    variant="dashboard"
    title={title}
    breadcrumbActions={actions}
    breadcrumbStartActions={startActions}
  >
    <div
      className={classNames(
        flush ? 'flex h-full min-h-0 flex-col overflow-hidden' : 'mx-auto w-full max-w-6xl px-4 py-6 sm:px-6',
        contentClassName
      )}
    >
      {children}
    </div>
  </AppShell>
);
